module.exports = __webpack_public_path__ + "img/centres_rivieres.9b57964f.webp";